


import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Tab extends Vue {
  @Prop() public activeTabId!: string;
  @Prop() public tabId!: string;
  @Prop() public tabTitle!: string;

  public get active(): boolean {
    return this.tabId === this.activeTabId;
  }
}
